'use client';

import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import styles from './StressModal.module.css';

export const StressModal = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="stress-modal-heading"
    >
      <div className="container">
        <h4 id="stress-modal-heading">
          {t('ring.bentoRecoverySection.stressCard.modal.head')}
        </h4>
        <h3>
          {t('ring.bentoRecoverySection.stressCard.modal.subHeadA')}
          <br /> {t('ring.bentoRecoverySection.stressCard.modal.subHeadB')}
        </h3>
        <div className="modal-items">
          <div className="item">
            <p className="text-mid">
              {t('ring.bentoRecoverySection.stressCard.modal.cardA.descA')}{' '}
              <span className="bold">
                {t('ring.bentoRecoverySection.stressCard.modal.cardA.descBold')}
              </span>{' '}
              {t('ring.bentoRecoverySection.stressCard.modal.cardA.descB')}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t(
                'stressModal.content.ariaLabel.stressImpactVisualization',
              )}
            >
              <Image
                src={'web_v2/ring-buy/recovery/svg/stressFlipAresp.svg'}
                fill
                alt=""
                className="sleep-index"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
